import { useEffect, useState } from "react";
import { Params } from "../../../api/commercial/url/params";
import { ProductRefType } from "../../../context/product-context/types";

const useProductRefUrlExtractor = ({
  providedProductRef,
}: {
  providedProductRef: ProductRefType;
}): ProductRefType => {
  const [productRef, setProductRef] = useState(providedProductRef);

  useEffect(() => {
    setProductRef(providedProductRef);
    window.history.replaceState({}, null, Params.productRef.remove());
  }, [providedProductRef]);

  return productRef;
};

export default useProductRefUrlExtractor;
